import React from 'react';

import { useCallbackRef } from '@/js/libs/hooks/useCallbackRef/index.ts';

import { BaseComponent } from '../BaseComponent.tsx';
import type { IconBaseProps, IconRender } from '../types.ts';

const Search = React.forwardRef<SVGSVGElement | null, IconBaseProps>(function Search({ dataTestId, ...props }, ref) {
  const iconRender = useCallbackRef<IconRender>((color: string) => (
    <>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M11 17.5C14.5899 17.5 17.5 14.5899 17.5 11C17.5 7.41015 14.5899 4.5 11 4.5C7.41015 4.5 4.5 7.41015 4.5 11C4.5 14.5899 7.41015 17.5 11 17.5ZM11 19C15.4183 19 19 15.4183 19 11C19 6.58172 15.4183 3 11 3C6.58172 3 3 6.58172 3 11C3 15.4183 6.58172 19 11 19Z'
        fill={color}
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M20.8232 21.1768C20.628 21.372 20.3114 21.372 20.1161 21.1768L15.8232 16.8839C15.628 16.6886 15.628 16.372 15.8232 16.1768L16.1768 15.8232C16.372 15.628 16.6886 15.628 16.8839 15.8232L21.1768 20.1161C21.372 20.3114 21.372 20.628 21.1768 20.8232L20.8232 21.1768Z'
        fill={color}
      />
    </>
  ));
  return <BaseComponent ref={ref} dataTestId={dataTestId ?? 'search-icon-svg'} iconRender={iconRender} {...props} />;
});

export default Search;
